import { of as observableOf, Observable } from 'rxjs';

import {
  filter,
  switchMap,
  share,
  map,
  catchError,
  mergeMap,
  debounceTime,
} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NotificationsAction } from './notifications.actions';
import { BackendService } from '../../services/backend/backend.service';
import { DefaultResponse } from '../../models/form/DefaultResponse';
import { AppState } from '../../interfaces/app-state.interface';
import { Action, Store } from '@ngrx/store';
import { RealtimeService } from '../../services/realtime/realtime.service';
import { RealtimeHub } from '../../enum/realtime/realtime-hub.enum';

@Injectable()
export class NotificationsEffects {
  constructor(
    private actions$: Actions<NotificationsAction>,
    private backendService: BackendService,
    private realTimeService: RealtimeService,
    private store: Store<AppState>
  ) {}

  getNotifications$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType(NotificationsAction.getNotifications),
        switchMap(() =>
          this.backendService
            .get<DefaultResponse>('communication/notificationhistoric')
            .pipe(
              map((result) =>
                result.ok
                  ? {
                      type: NotificationsAction.getNotificationsSuccess,
                      payload: result.value,
                    }
                  : {
                      type: NotificationsAction.getNotificationsError,
                      payload: result.value,
                    }
              ),
              catchError((e) =>
                observableOf({
                  type: NotificationsAction.getNotificationsError,
                  payload: e,
                })
              )
            )
        ),
        share()
      )
  );

  readNotification$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType(NotificationsAction.readNotification),
        mergeMap((action) =>
          this.backendService
            .post<DefaultResponse>(
              'communication/setreadstatus',
              action.payload
            )
            .pipe(
              map((result) =>
                result.ok
                  ? {
                      type: NotificationsAction.readNotificationSuccess,
                      payload: action.payload,
                    }
                  : {
                      type: NotificationsAction.readNotificationError,
                      payload: result.value,
                    }
              ),
              catchError((e) =>
                observableOf({
                  type: NotificationsAction.readNotificationError,
                  payload: e,
                })
              )
            )
        ),
        share()
      )
  );

  /**
   * Notificações em tempo real
   */
  getNotificationRealtime$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationsAction.subscribeNotificationChannel),
      filter(() =>
        this.realTimeService.registerSubscribersAndCheckIfSubscriptionIsNeeded(
          RealtimeHub.Notification
        )
      ),
      switchMap(
        (): Observable<Action> =>
          this.realTimeService.subscribeToNotifications().pipe(
            debounceTime(300),
            filter((data: any) => !!data.Body),
            map(
              (notification: any) =>
                ({
                  type: NotificationsAction.subscribeNotificationChannelSuccess,
                  payload: {
                    body: notification.Body.Body,
                    details: notification.Body.Detail,
                    readStatus: notification.Body.ReadStatus || 0,
                    sendDate: notification.Body.SendDate,
                    messageID: notification.Body.GuidID,
                  },
                } as Action)
            ) // 🔹 Cast explícito para `Action`
          )
      )
    )
  );
}
